<template>
  <section
      ref="container"
      class="col-start-1 col-end-13 row-start-4 row-end-5"
  >
    <div class="grid grid-cols-columns" ref="calculator-items">
      <div class="col-start-2 col-end-12">
        <div class="container mx-auto pt-10 xxl:px-6" v-if="!step">
          <calculator-cta @swapComponent="onComponentChange"/>
        </div>
        <div v-else class="container mx-auto pt-10 xxl:px-6">
          <div class="xl:grid xl:grid-cols-12 xl:gap-8 items-center">
            <calculator-page-style
                v-if="step === 'calculator-page-style'"
                :component-name="step"
                :tempStep="tempStep"
                @swapComponent="onComponentChange"/>
            <calculator-page-structure
                v-else-if="step === 'calculator-page-structure'"
                :component-name="step"
                :tempStep="tempStep"
                @swapComponent="onComponentChange"            />
            <calculator-additional
                v-else-if="step === 'calculator-additional'"
                :component-name="step"
                :tempStep="tempStep"
                @swapComponent="onComponentChange"/>
            <calculator-google
                v-else-if="step === 'calculator-google'"
                :component-name="step"
                :tempStep="tempStep"
                @swapComponent="onComponentChange"
            />
            <calculator-end
                v-else-if="step==='calculator-end'"
                @messageSent="messageSent"
            />
            <div ref="calculator" class="xl:col-span-4">
              <div class="mt-6 xl:mt-0 md:max-w-2xl xl:max-w-full mx-auto">
                <next-button class="xl:hidden" :value="step" @onNext="preComponentChange"/>
                <calculator/>
                <next-button class="hidden xl:block" :value="step" @onNext="preComponentChange"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Calculator from "./Calculator";
import CalculatorCta from "./calculator-cta/CalculatorCta";
import CalculatorPageStyle from "./calculator-page-style/CalculatorPageStyle";
import NextButton from "@/components/calculator-steps/utils/NextButton";

import {gsap} from 'gsap'
import CalculatorPageStructure from "@/components/calculator-steps/calculator-page-structure/CalculatorPageStructure";
import CalculatorAdditional from "@/components/calculator-steps/calculator-additional/CalculatorAdditional";
import CalculatorGoogle from "@/components/calculator-steps/calculator-google/CalculatorGoogle";
import CalculatorEnd from "@/components/calculator-steps/calculator-end/CalculatorEnd";

export default {
  name: "CalculatorSteps",
  components: {
    Calculator,
    CalculatorCta,
    CalculatorPageStyle,
    CalculatorPageStructure,
    CalculatorAdditional,
    CalculatorGoogle,
    CalculatorEnd,
    NextButton

  },
  data() {
    return {
      step: undefined,
      tempStep: undefined,
    };
  },
  computed: {
    calculatorRef() {
      return this.$refs['calculator']
    },
    calculatorItems() {
      return this.$refs['calculator-items']
    }
  },
  methods: {
    messageSent() {
      this.$emit('messageSent')
      this.step = undefined;
      this.tempStep = undefined;
      this.$store.dispatch('prices/LOAD')
    },
    onComponentChange(step) {
      if (!this.step) {
        this.step = step;
        this.$nextTick(() => {
          gsap.set(this.calculatorRef, {autoAlpha: 0, y: 50})
          gsap.to(this.calculatorRef, {autoAlpha: 1, y: 0, ease: 'slow'})
        })
      } else {
        this.step = step
      }
    },
    preComponentChange(step) {
      this.tempStep = step;
    },
  },
  mounted() {

  },
};
</script>

<style>
</style>
